import { createContext } from 'react';
import { IServerError, ISerialNumberExistsValidationError, ICreateWatch } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface ICreateWatchState {
	serialNumber: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	dataForSubmit: Nullable<ICreateWatch>;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: Nullable<IServerError<ISerialNumberExistsValidationError>>;
}

export const createWatchInitialState: ICreateWatchState = {
	serialNumber: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	dataForSubmit: null,
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface ICreateWatchContext extends ICreateWatchState {
	changeSerialNumber(value: string): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setDataForSubmit(value: Nullable<ICreateWatch>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(value: Nullable<IServerError<ISerialNumberExistsValidationError>>): void;
	resetFields(): void;
}

export const CreateWatchContext = createContext<ICreateWatchContext>({
	changeSerialNumber: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	resetFields: () => undefined,
	...createWatchInitialState,
});
